export class RequisitionsQueryFilter {
    constructor(companyId) {
        this.companyId = companyId;
        this.clientOrBU = [];
        this.roleList = [];
        this.requisitionNums = [];
        this.recruiters = [];
        this.requisitionTypes = [];
        this.jobTypes = [];
        this.workLocationIds = [];
        this.requisitionStates = [];
        this.searchCheck = false;
        this.searchText = "";
        this.size = 9;
        this.pageNum = 1;
        this.fromDate = "";
        this.toDate = "";
        this.sortColumn = "";
        this.sortDirection = "";
        this.isAssignedToMe = true;
        this.isAssignedToOthers = true;
        this.isUnassigned = true;
        this.isAllRequisition = true;
        this.isSharedWithMe = true;
    }
}
//# sourceMappingURL=requisitions-query-filter.model.js.map